function QrOne({ width, height }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} data-name="Group 4196" viewBox="0 0 24 24">
      <g data-name="Group 1269">
        <path fill="#fff" d="M0 0h24v24H0z" data-name="Path 266" />
        <text fill="#0070b6" data-name="" fontFamily="JioMoney" fontSize="22" transform="translate(1 22)">
          <tspan x="0" y="0">
            
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default QrOne
